import styled, { css } from 'styled-components';

const FlexItem = styled.div`
  flex: 1;
  position: relative;


  ${({width}) => width && css`
    width: ${width};
  `}; 
  
  ${({basis}) => basis && css`
    flex: 0 0 ${basis * 100}%;
  `};
`;

export default FlexItem;



// WEBPACK FOOTER //
// ./src/core/layout/components/FlexItem/FlexItem.js